import { render, staticRenderFns } from "./edit_addres.vue?vue&type=template&id=ba8c6742&scoped=true"
import script from "./edit_addres.vue?vue&type=script&lang=js"
export * from "./edit_addres.vue?vue&type=script&lang=js"
import style0 from "./edit_addres.vue?vue&type=style&index=0&id=ba8c6742&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8c6742",
  null
  
)

export default component.exports